import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Action } from 'redux';
import { NoOp } from '../../ui/action-creators';
import { SetActiveLabel } from '../action-creators';
import { SET_ACTIVE_LABEL } from '../actions';
import { setLastActiveLabelId } from '../../../utils/record-labels/last-active';

export const updateLastActiveLabelEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, SetActiveLabel>(SET_ACTIVE_LABEL),
    map((action) => {
      setLastActiveLabelId(action.label.id);

      return new NoOp();
    })
  );
